// DAS-2768: full-width warning banner shown ONLY while the market weather is
// PANIC. The referee-with-a-whistle: it cannot block a trade, it holds up the
// owner's own pre-agreed rule and the April 2025 evidence at the exact moment
// the urge to sell is strongest. Self-contained (fetches its own data, renders
// null otherwise) so it can be mounted on any page — pattern: CapitalFitBanner.
import React, { useState, useEffect } from 'react';
import { Alert } from 'antd';
import api from '../functions/api';

const PanicBanner = () => {
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    api.get('/market_weather')
      .then(res => setWeather(res.data?.current || null))
      .catch(() => setWeather(null));
  }, []);

  if (!weather || weather.weather !== 'PANIC') return null;

  return (
    <Alert
      data-testid="panic-banner"
      type="error"
      showIcon
      banner
      style={{ marginBottom: 12 }}
      message={<b>MARKET PANIC — your own agreement is active: no sales of long-term holdings for 48 hours.</b>}
      description={
        <>
          Before any sell, answer one question: <b>has the company's story changed — or only the price?</b>{' '}
          Your own evidence (April 2025): panic sales cost ~€54,000 — the sold shares rose a median 165% afterwards.
          There is no profitable panic sale in your history. Market weather per {weather.date}: {weather.drawdown_pct}% under
          the 1-year top, wildness {weather.wildness_pct}%.
        </>
      }
    />
  );
};

export default PanicBanner;
